import { settings } from '../shared/constants';
import { get } from '../shared/services/FetchService';
import TrackingUtils from '../../assets/components/fsUtils/TrackingUtils';


class Collections {
	constructor(success, data) {
		this.success = success || false;
		this.data = data || [];
	}
}

class VideoCollectionsService {
	constructor() {
		this.getCollectionsProm = null;
		this.count = 0;
	}

	getCollections ( postId ) {
		if (this.getCollectionsProm) {
			return this.getCollectionsProm;
		}

		this.getCollectionsProm = get(settings.COLLECTIONS_URL + postId,
			json => {
				if (!json.success) return [];
				let data = json.data;
				return Array.isArray(data) ? data : [data];
			},
			() => []);

		return this.getCollectionsProm;
	}
	setCollectionUTM(collection, idx){
		// if index isn't set, use internal counter
        if(typeof idx === 'undefined') this.count++;

        let result = {
            source      : 'homepage',
        };
        result.term = (typeof idx !== 'undefined') ? 'collection_' + idx : 'collection_' + this.count;
        /* if tags aren't present, convert the collection's title as a tag/slug for "utm_content" use. */
        /* 'undefined' if title is not set */
        result.content = (collection.tags && collection.tags.length > 0) ? collection.tags[0] : (typeof collection.collectionTitle !== 'undefined') ? TrackingUtils.formatStringAsSlug(collection.collectionTitle) : undefined;

		return result;
	}
}

export default new VideoCollectionsService();



// WEBPACK FOOTER //
// ./react-app-src/videoCollections/VideoCollectionsService.js